export default {
  id: 'creating-account',
  title: 'Creating Your Account',
  content: `## Creating Your Account

Getting started with TradeLab takes under two minutes.

---

## Step 1 — Open the App

Navigate to the TradeLab URL in your browser. You will land on the home page with a **Sign In** and **Get Started** button.

---

## Step 2 — Sign Up

Click **Get Started**. You will be taken to the signup page.

Fill in the following fields:

| Field | Description |
|---|---|
| Full Name | Your display name shown across the app |
| Email | Used for login and report delivery |
| Password | Minimum 8 characters |

Click **Create Account**.

> Your account starts with **₹10,00,000 virtual capital** automatically. No setup needed.

---

## Step 3 — Log In

Once your account is created, you are redirected to the login page. Enter your email and password and click **Sign In**.

---

## Step 4 — You're In

You land on the **Home dashboard**. From here you can:

- See your portfolio summary
- Access all features from the bottom navigation
- Start your first trade or ACT session

---

## Forgot Password

On the login page, click **Forgot Password**. Enter your registered email and follow the instructions sent to your inbox.

---

## Account Limits

| Property | Value |
|---|---|
| Starting virtual capital | ₹10,00,000 |
| Supported exchange | NSE only |
| Real money involved | None |`,
};
